export default __webpack_public_path__ + "static/media/hypercat-crying.d957f8ca.png";